(function ($) {
   /**
    * Functionality to open and close accordion items
    */
   $(
      '.wp-block-accordion .wp-block-accordion__item .wp-block-accordion__item-title button',
   ).each(function () {
      $(this).on('click', function () {
         const $item = $(this).closest('.wp-block-accordion__item');
         const $accordion = $(this).closest('.wp-block-accordion');

         if ($item.hasClass('is-expanded')) {
            $item.removeClass('is-expanded');
         } else {
            $accordion
               .find('.wp-block-accordion__item.is-expanded')
               .removeClass('is-expanded');
            $item.toggleClass('is-expanded');
         }
      });
   });
   /**
    * Data table initialization and functionality
    */
   let tables = {};
   $(function () {});
})(jQuery);
